import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Heart, ArrowLeft, Dumbbell } from "lucide-react";

export default function Favorites() {
  const { favorites } = useAuth();

  return (
    <div className="min-h-screen pt-24 pb-12 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <Link to="/exercises">
            <Button variant="ghost" size="icon">
              <ArrowLeft className="w-5 h-5" />
            </Button>
          </Link>
          <div>
            <h1 className="text-3xl font-bold flex items-center gap-2">
              <Heart className="w-8 h-8 text-red-500 fill-red-500" />
              Favorite Exercises
            </h1>
            <p className="text-muted-foreground">
              Your saved exercises for quick access
            </p>
          </div>
        </div>

        {/* Favorites Grid */}
        {favorites.length === 0 ? (
          <Card className="p-12 text-center">
            <Heart className="w-16 h-16 text-muted-foreground mx-auto mb-4" />
            <h2 className="text-xl font-semibold mb-2">No Favorites Yet</h2>
            <p className="text-muted-foreground mb-6">
              Start adding exercises to your favorites for quick access
            </p>
            <Link to="/exercises">
              <Button className="bg-amber-500 text-black hover:bg-lime-500">
                Browse Exercises
              </Button>
            </Link>
          </Card>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
            {favorites.map((fav) => (
              <Card
                key={fav.id}
                className="p-4 hover:border-amber-500/50 transition-colors"
              >
                <div className="flex items-start justify-between">
                  <Link
                    to={`/exercises/${fav.exerciseId}`}
                    className="flex-1"
                  >
                    <Dumbbell className="w-8 h-8 text-amber-500 mb-3" />
                    <h3 className="font-semibold text-sm capitalize line-clamp-2">
                      {fav.exerciseName}
                    </h3>
                    <p className="text-xs text-muted-foreground mt-1">
                      Added {new Date(fav.createdAt).toLocaleDateString()}
                    </p>
                  </Link>
                  <Button
                    variant="ghost"
                    size="icon"
                    className="text-red-500"
                  >
                    <Heart className="w-4 h-4 fill-red-500" />
                  </Button>
                </div>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
